export default class CalendarDay {
  constructor(number, dayOfWeek, startDate, endDate, events, isCurrentMonth) {
    this.number = number;
    this.dayOfWeek = dayOfWeek;
    this.startDate = startDate;
    this.endDate = endDate;
    this.events = events;
    this.isCurrentMonth = isCurrentMonth || true;
  }
}
